// extracted by mini-css-extract-plugin
export var actionButton = "_q5-0";
export var actionMenuContainer = "_q5-i";
export var bubble = "_q5-2";
export var bubbleActionMenu = "_q5-j";
export var bubbleContext = "_q5-6";
export var bubbleItems = "_q5-7";
export var customer = "_q5-3";
export var divider = "_q5-8";
export var fileList = "_q5-9";
export var hiddenComment = "_q5-o";
export var infoAbove = "_q5-a";
export var internal = "_q5-4";
export var lightActionButton = "_q5-1";
export var link = "_q5-b";
export var merchant = "_q5-5";
export var message = "_q5-c";
export var profilePicture = "_q5-e";
export var quillToolbarContainer = "_q5-f";
export var senderDate = "_q5-g";
export var senderDateCustomer = "_q5-h";
export var senderName = "_q5-d";
export var time = "_q5-k";
export var uploadedImage = "_q5-l";
export var username = "_q5-m";
export var xsmall = "_q5-n";